import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditContact from "../../Components/Admin/AdminEditContact";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditContactPage = () => {
  return (

    <AdminEditContact />

  );
};

export default AdminEditContactPage;